import { EyeStroke, FileMultipleStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoColoredDot, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onAddIconClick: () => void;
  onEditIconClick: () => void;
  onDeleteIconClick: () => void;
  onCopyIconClick: () => void;
  onWatchIconClick: () => void;
  onRefreshClick?: () => void;
  hasRowSelected?: boolean;
}

const ActionBar: React.FC<ActionBarProps> = ({
  onAddIconClick,
  onEditIconClick,
  onDeleteIconClick,
  onCopyIconClick,
  onWatchIconClick,
  onRefreshClick,
  hasRowSelected = false
}) => {
  return (
    <ActionBarV2
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Tỷ giá quy đổi ngoại tệ</h1>
          <div className='mt-1 flex items-center'>
            <AritoColoredDot color='#FF0000' size={6} className='mr-2' />
            <span className='text-xs text-gray-600'>Cập nhật tỷ giá</span>
          </div>
        </div>
      }
    >
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddIconClick} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditIconClick} disabled={!hasRowSelected} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteIconClick} disabled={!hasRowSelected} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyIconClick} disabled={!hasRowSelected} />
      <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onWatchIconClick} disabled={!hasRowSelected} />
      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={18} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: () => {},
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
